import React, { useEffect, useState, useMemo } from "react";
import { useMediaQuery } from "react-responsive";
import BannerSlide from "@/app/components/UI/BannerSlide";
import { BannerSectionProps } from "@/app/interface/components";
import router from "next/router";
import classNames from "classnames";
import styles from "@/styles/desktop/Home/BannerSection.module.scss";

const BannerSection: React.FC<BannerSectionProps> = ({
  setIsConditionsModalOpen,
  setConditionsContent,
  setChatbotOpen,
  bannerImagesMobile,
  bannerImagesTablet,
  links,
  calls,
  className,
}) => {
  const isTablet = useMediaQuery({ minWidth: 540 });

  const banners = useMemo(() => {
    if (isTablet) return bannerImagesTablet;
    return bannerImagesMobile;
  }, [isTablet, bannerImagesTablet, bannerImagesMobile]);

  if (!banners || banners.length === 0) return null;

  return (
    <section className={classNames(styles.main, {
      [styles.noTopPadding]: router.pathname === '/TPHiace'
    }, className)}>  
      <BannerSlide
        banners={banners!}
        links={links}
        calls={calls}
        setChatbotOpen={setChatbotOpen}
        width={isTablet ? 1024 : 430}
        height={isTablet ? 1204 : 504}
        setIsConditionsModalOpen={setIsConditionsModalOpen}
        setConditionsContent={setConditionsContent}
        className={router.pathname === '/TPHiace' ? 'no-padding-mobile' : ''}
      />
    </section>
  );
};

export default React.memo(BannerSection);
